import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Container, AppBar, Toolbar, Typography, Box, Button, Link } from '@mui/material';
import Dashboard from './pages/Dashboard';
import KundenPage from './pages/KundenPage';
import NutzerPage from './pages/NutzerPage';
import AntragstellungPage from './pages/AntragstellungPage';
import AntraegePage from './pages/AntraegePage';
import ZulassungsantragDetailPage from './pages/ZulassungsantragDetailPage';
import SabrinaPage from './pages/SabrinaPage';
import Gks02Page from './pages/Gks02Page';
import ProtokollPage from './pages/ProtokollPage';
import DokumentationPage from './pages/DokumentationPage';
import KennzeichenSuchePage from './pages/KennzeichenSuchePage';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import LoginPage from './pages/LoginPage';
import ProfilPage from './pages/ProfilPage';
import EinstellungenPage from './pages/EinstellungenPage';
import { useAuth } from './context/AuthContext';

// Material-UI Theme für GKS
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Blau für GKS
    },
    secondary: {
      main: '#dc004e', // Rot für Akzente
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 500,
    },
  },
});

function App() {
  const { token, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ flexGrow: 1 }}>
          {/* Header */}
          <AppBar position="static">
            <Toolbar>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                GKS - Großkundenschnittstelle
              </Typography>
              {token ? (
                <Box display="flex" alignItems="center" gap={2}>
                  <Link
                    component="button"
                    variant="body2"
                    color="inherit"
                    underline="hover"
                    onClick={() => navigate('/profil')}
                    sx={{ cursor: 'pointer' }}
                  >
                    Angemeldet als {user?.vorname && user?.nachname ? `${user.vorname} ${user.nachname}` : user?.username}
                  </Link>
                  <Button color="inherit" onClick={handleLogout}>Abmelden</Button>
                </Box>
              ) : (
                <Typography variant="body2">Fahrzeugzulassung für Großkunden</Typography>
              )}
            </Toolbar>
          </AppBar>

          {/* Navigation */}
          {token && <Navigation />}

          {/* Main Content */}
          <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <Routes>
              {/* Public route */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected routes */}
              <Route element={<ProtectedRoute />}> 
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/antragstellung" element={<AntragstellungPage />} />
                <Route path="/zulassungsantraege" element={<AntraegePage />} />
                <Route path="/zulassungsantraege/:id" element={<ZulassungsantragDetailPage />} />
                <Route path="/sabrina" element={<SabrinaPage />} />
                <Route path="/profil" element={<ProfilPage />} />

                {/* Admin-only routes */}
                <Route element={<AdminRoute />}>
                  <Route path="/einstellungen" element={<EinstellungenPage />} />
                  <Route path="/kunden" element={<KundenPage />} />
                  <Route path="/sabrina/gks02" element={<Gks02Page />} />
                  <Route path="/nutzer" element={<NutzerPage />} />
                  <Route path="/protokoll" element={<ProtokollPage />} />
                  <Route path="/dokumentation" element={<DokumentationPage />} />
                  <Route path="/kennzeichensuche" element={<KennzeichenSuchePage />} />
                </Route>
              </Route>
            </Routes>
          </Container>
        </Box>
    </ThemeProvider>
  );
}

export default App;
